import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import {connect} from "react-redux";
import {ACTION_TYPES, actions} from "../../actions";
import {BASENAME} from "../../constants";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import _ from 'lodash';


class AssessmentsSearchBar extends Component{
    constructor(props){
        super(props);
        this.state={
            suggestions:[],
            query:'',
            inputValue:''
        }
    }

    async componentDidUpdate(prevProps,prevState){
        if(prevState.inputValue!=this.state.inputValue){
            await this.setQueryProps(this.state.inputValue)
        }
    }

    setQueryProps = async function(query){
        const queryObj = {searchQuery:query}
        await this.props.setNewFields({
            type:ACTION_TYPES.SET_FIELDS.SET_FILTER_INPUTS,
            payload:{...this.props.form,...queryObj,...{college:{name:''}, department:{name:''}, program:{name:''}, selection:'search', page:0}}
        })
            .then(this.props.fetchDepartments('resetDepartmentsList'))
            .then(await this.props.fetchPrograms('resetProgramsList'))
    }

    setOptions(suggestionObjects){
        let suggestions = [];
        if(suggestionObjects&&suggestionObjects.length>0){
            suggestionObjects.map(suggestion=>{
                //filter assessment name match query
                if(suggestion.name.toLowerCase().startsWith(this.state.query.toLowerCase())){
                    suggestions.push(suggestion.name);
                }
                //filter for field names matching query
                for (let key in suggestion) {
                    if (suggestion.hasOwnProperty(key)) {
                        if(suggestion[key].name&&suggestion[key].name.toLowerCase().startsWith(this.state.query.toLowerCase())){
                            suggestions.push(suggestion[key].name);
                        }
                    }
                }
            });
        }
        const filteredSuggestions = _.uniq(suggestions);
        this.setState({suggestions:filteredSuggestions});
        return filteredSuggestions
    }

    getSuggestions = () => {
        const fetchName = this.state.query
        fetch(`${BASENAME}/api/filtered_assessments?fetchType=filtered&page=1&limit=7&fetchName=${fetchName}`)
            .then(res => res.json())
            .then(data => {
                this.setOptions(data.docs);
            })
    }

    handleQueryChange=()=>(e)=>{
        this.setState({query:e.target.value},async ()=>{
            if(this.state.query && this.state.query.length>1){
                if( this.state.query.length%2==0){
                    await this.getSuggestions()
                }
            }
        });
    }

    handleAutocompleteChange = async(event, value) =>{
        //reset inputValue to zero to trigger update when same autocomplete option is selected
        if(value == this.state.inputValue){
            await this.setState({inputValue:''})
            await this.forceUpdate();
        }
        value = value==null?'':value;
        this.setState({inputValue:value});
    }

    handleSubmit=()=>async()=>{
        this.setState({inputValue:this.state.query})
    }

    handleEnterSearch=()=>async(e)=>{
        if (e.key === 'Enter') {
            this.setState({inputValue:this.state.query})
        }
    }

    render(){
        return(
            <div style={{width:'20%', float:'right'}}>
                <Autocomplete
                    id="assessment-search"
                    value = {this.props.form.searchQuery?this.props.form.searchQuery:''}
                    onChange={this.handleAutocompleteChange}
                    options={this.state.suggestions.map((option) => option)}
                    renderInput={(params) => (
                        <TextField
                           {...params}
                           label="Search Assessments"
                           onChange = {this.handleQueryChange()}
                           onKeyDown={this.handleEnterSearch()}
                           margin="normal"
                           variant="outlined"
                           InputProps={{
                               ...params.InputProps,
                               style:{paddingRight:'15px'},
                               type: 'search',
                               endAdornment:
                                   (
                                       <InputAdornment>
                                           <IconButton onClick={this.handleSubmit()}>
                                               <SearchIcon/>
                                           </IconButton>
                                       </InputAdornment>
                                   )
                           }}
                        />
                    )}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        form:state.filteredAssessmentsForm,
    };
}

export default connect(mapStateToProps,actions)(AssessmentsSearchBar);
